import Cookies from 'js-cookie';

import { getCachedNativeIds } from '../../analytics/nativeFirebase';

/**
 * "_ga" cookie: "GA1.1.<random>.<timestamp>" → client_id "<random>.<timestamp>"
 * @param {string|null|undefined} cookieValue
 */
export const parseGaClientId = (cookieValue) => {
  if (!cookieValue) return null;
  const parts = cookieValue.split('.');
  return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : null;
};

/**
 * "_ga_<stream>" session cookie. Two formats coexist:
 *   GS1: "GS1.1.<session_id>.<n>..."       → bare id in parts[2]
 *   GS2: "GS2.1.s<session_id>$o2$g1$t..."  → id packed as "s<id>$..." (2025+)
 * @param {string|null|undefined} cookieValue
 */
export const parseGaSessionId = (cookieValue) => {
  if (!cookieValue) return null;
  const parts = cookieValue.split('.');
  if (parts.length < 3 || !parts[2]) return null;
  const segment = parts[2];
  if (segment.includes('$')) {
    const match = segment.split('$')[0].match(/^s(\d+)$/);
    return match ? match[1] : null;
  }
  return segment;
};

/**
 * Reads GA/FB identifiers from first-party cookies (web and Cordova webview).
 * In the Cordova apps the native Firebase Analytics ids (app_instance_id /
 * session id, cached by nativeFirebase.js) ride along so the server-side
 * Measurement Protocol mirror can target the app data stream.
 * @returns {{gaClientId: string|null, gaSessionId: string|null, fbp: string|null, fbc: string|null,
 *            appInstanceId?: string|null, appSessionId?: string|null, appPlatform?: 'android'|'ios'|null}}
 */
export const collectTrackingIds = () => {
  if (typeof document === 'undefined') return { gaClientId: null, gaSessionId: null, fbp: null, fbc: null };
  const all = Cookies.get();
  const gaSessionCookie = Object.keys(all).find((name) => name.startsWith('_ga_'));
  const { appInstanceId, appSessionId, appPlatform } = getCachedNativeIds();
  return {
    gaClientId: parseGaClientId(all._ga),
    gaSessionId: parseGaSessionId(gaSessionCookie ? all[gaSessionCookie] : null),
    fbp: all._fbp || null,
    fbc: all._fbc || null,
    ...(appInstanceId ? { appInstanceId, appSessionId, appPlatform } : {}),
  };
};
